import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PasswordAction from '../actions/PasswordAction';
import ForgotPassword from '../../components/ForgotPassword/ForgotPassword';

const mapStateToProps = (state) => {
  const email = (state.form.forgotPassword.values) ? state.form.forgotPassword.values.email : '';
  return { email };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    submitForgotPassword: PasswordAction.submitForgotPassword
  }, dispatch);


const ForgotPasswordContainer = connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

export default ForgotPasswordContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ForgotPasswordContainer.js
 **/